// extracted by mini-css-extract-plugin
export default {"wrap":"qG-z","articleImagesWrap":"rG-z","articleImage":"sG-z","singleImage":"tG-z"};